<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: left">
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              type="danger"
              >新增
            </el-button>
          </div>
          <div style="float: right">
            <!-- <OfSearch
              @search="search"
              style="float: left; padding-right: 10px"
              :placeholder="placeholder"
            ></OfSearch> -->
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchModel.searchKey"
              clearable
              :placeholder="placeholder"
            />
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="search"
              >查询</el-button
            >
          </div>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="Id"
            label="项目编号"
            align="left"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="Name"
            label="项目名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Leader"
            label="项目负责人"
            align="center"
            :show-overflow-tooltip="true"
            width="140"
          ></el-table-column>
          <el-table-column label="设立时间" align="center" width="140">
            <template slot-scope="scope">
              {{ (scope.row.EstablishTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Status"
            label="项目状态"
            align="center"
            :formatter="showStatus"
            width="100"
          ></el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                v-if="isInnerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑
              </el-button>
              <el-button
                v-access:read
                @click="innerRead(scope.row)"
                type="text"
                size="mini"
                >详情
              </el-button>
              <el-button
                v-access:modify
                @click="innerApprove(scope.row)"
                v-if="isInnerEdit(scope.row)"
                type="text"
                size="mini"
                >送审
              </el-button>
              <el-button
                v-access:modify
                @click="innerRelease(scope.row)"
                v-if="isAudit(scope.row)"
                type="text"
                size="mini"
                >发布
              </el-button>
              <el-button
                v-access:delete
                @click="innerDel(scope.row)"
                v-if="isInnerEdit(scope.row)"
                type="text"
                size="mini"
                >删除
              </el-button>
              <el-button
                v-access:read
                @click="gotoProg(scope.row)"
                type="text"
                size="mini"
                v-if="isRelease(scope.row)"
                >项目进展
              </el-button>
              <el-button
                v-access:modify
                @click="gotoprojectexpend(scope.row)"
                v-if="isRelease(scope.row)"
                type="text"
                size="mini"
                >支出
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          />
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :isDisabled="isEdit"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    />
    <ModuleQuery
      v-if="formDataQuery"
      :dataForm="formData"
      :isDisabled="isEdit"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    />
    <el-dialog
      title="项目进展"
      :visible.sync="showProgress"
      :close-on-click-modal="false"
      width="75%"
      :before-close="handleClose"
    >
      <ProgressList :ImplementId="progressId" />
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="showExpend"
      :close-on-click-modal="false"
      width="75%"
      :before-close="handleClose"
    >
      <Addprojectexpend :ImplementId="expendId" />
    </el-dialog>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit from "@/modules/zjrc/pages/material/implementproject/edit";
import ModuleQuery from "@/modules/zjrc/pages/material/implementproject/query";
import ProgressList from "@/modules/zjrc/pages/material/implementproject/progress/list";
import Addprojectexpend from "@/modules/zjrc/pages/material/implementproject/addprojectexpend/list";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";
import { mapGetters } from "vuex";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formDataQuery: false,
      formDataProgress: false,
      formTitle: "",
      formData: {},
      total: 0,
      currentPage: 1,
      pageSize: 15,
      //搜索字段
      searchModel: {
        status: "",
        searchKey: "",
      },
      placeholder: "单号",
      isEdit: false,
      showProgress: false, // 项目进展弹窗
      progressId: "",
      showExpend: false,
      expendId: "",
    };
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit,
    ModuleQuery,
    ProgressList,
    Addprojectexpend,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    isInnerEdit() {
      return (rowData) => {
        return rowData.Status == 0 ? true : false;
      };
    },
    isRelease() {
      return (rowData) => {
        return rowData.Status == 3 ? true : false;
      };
    },
    isAudit() {
      return (rowData) => {
        return rowData.Status == 2 ? true : false;
      };
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    handleClose() {
      const vm = this;
      vm.showProgress = false;
      vm.showExpend = false;
    },
    //初始化数据
    loadData() {
      this.isloading = true;
      let params = {
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
        keyWord: this.searchModel.searchKey,
      };
      api.QueryImplementProjectImplement(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          var data = rep.data.Data.rows;
          this.listData = data;
        }
        this.isloading = false;
      });
    },
    //新增
    add() {
      this.isEdit = false;
      this.formTitle = "新增实施项目";
      this.formData = {};
      this.formVisible = true;
    },
    //编辑
    innerEdit(rowData) {
      this.isEdit = false;
      this.formTitle = "编辑资金收入";
      this.formData = Object.assign({}, rowData);
      this.formData.EstablishTime = rowData.EstablishTime * 1000;
      this.formVisible = true;
    },
    //详情
    innerRead(rowData) {
      this.isEdit = true;
      this.formTitle = "查看详情";
      this.formData = Object.assign({}, rowData);
      this.formDataQuery = true;
    },
    //跳转到项目进展
    gotoProg(rowData) {
      // let that = this;
      // that.$router.push({
      //   path: "/zjrc/implementproject/progress/list",
      //   query: { Id: rowData.Id },
      // });
      const vm = this;
      vm.progressId = rowData.Id;
      vm.showProgress = true;
    },
    formCallBack(data) {
      this.formVisible = false;
      this.formDataQuery = false;
      this.formDataProgress = false;
      if (data != null) {
        this.loadData();
      }
    },
    //跳转到支出
    gotoprojectexpend(rowData) {
      // let that = this;
      // that.$router.push({
      //   path: "/zjrc/implementproject/projectexpend/list",
      //   query: { Id: rowData.Id },
      // });
      const vm = this;
      vm.expendId = rowData.Id;
      vm.showExpend = true;
    },
    //发布
    innerRelease(rowData) {
      this.$confirm("请确认是否发布选中的实施项目？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let that = this;
          that.isloading = true;
          let params = { Id: rowData.Id, Status: 3 };
          api.UpdateImplementProjectStatus(params).then((res) => {
            if (res.data.Code == 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentPage = 1;
              this.loadData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
            that.isloading = false;
          });
        })
        .catch((e) => {
          that.isloading = false;
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //送审
    innerApprove(rowData) {
      this.$confirm("请确认是否发布选中的实施项目？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isloading = true;
        let params = Object.assign({}, rowData);
        params.ProcName = "实施项目审核";
        params.Creator = this.GetCurrentUserInfo.RealName;
        params.CreatorId = this.GetCurrentUserInfo.Id;
        api.ForReviewImplementProject(params).then((rep) => {
          if (rep.data.Code == 0) {
            this.loadData();
          }
        });
      });
    },
    //状态
    showStatus(rowData) {
      switch (rowData.Status) {
        case 0:
          return "草稿";
        case 1:
          return "审核中";
        case 2:
          return "已审核";
        case 3:
          return "启动中";
        case 4:
          return "已结束";
      }
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.loadData();
    },
    //删除
    innerDel(rowData) {
      this.$confirm("请确认是否删除选中的实施项目？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api
          .DeleteImplementProject(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentPage = 1;
              this.loadData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 280;
      }
      return tableMaxHeight;
    },
  },
};
</script>

<style scoped>
.list-form {
  padding: 20px;
  box-sizing: border-box;
  float: left;
  overflow: auto;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-select >>> .el-input__inner {
  width: 3rem;
}

.el-row >>> .el-date-editor {
  width: 2.5rem !important;
}
</style>
